import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { SettingsState } from 'models';
import { EnhancedPayloadAction } from '../helpers';

const initialState: SettingsState = {
  expires_in_start: null,
  access_token: null,
  refresh_token: null,
  token_type: null,
  expires_in: null,
  current_portal: null,
  current_cooperative: null,
  refer: '/',
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setAuthorizationSettings(state, action) {
      return { ...state, ...action.payload };
    },
    resetAuthorizationSettings() {
      return {
        expires_in_start: null,
        access_token: null,
        refresh_token: null,
        token_type: null,
        expires_in: null,
        current_portal: null,
        current_cooperative: null,
        refer: '/',
      };
    },
    setPortal(
      state,
      action: EnhancedPayloadAction<SettingsState, 'current_portal'>
    ) {
      state.current_portal = action.payload;
    },
    setCooperative(
      state,
      action: EnhancedPayloadAction<SettingsState, 'current_cooperative'>
    ) {
      state.current_cooperative = action.payload;
    },
    setRefer(state, action: EnhancedPayloadAction<SettingsState, 'refer'>) {
      state.refer = action.payload;
    },
  },
});

export const { actions } = settingsSlice;
export default persistReducer(
  {
    key: 'settings',
    storage,
  },
  settingsSlice.reducer
);
